import { Placeholder } from '@sitecore-jss/sitecore-jss-react';
import React, { useEffect, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import { errorMessages } from '../../../../utils/errors/constants';
import useErrorState from '../../../../utils/errors/useErrorState';
import { resolve } from '../../../../utils/object/pathResolver';
import Tooltip from '../../../common/Tooltip';

const RadioQuestion = ({ rendering, fields, displayErrors, defaultValue, onError }) => {
  const [selectedValue, setSelectedValue] = useState(defaultValue || fields.defaultOption?.value);
  const dispatch = useDispatch();
  const [error, setError] = useErrorState(rendering.uid, fields.name?.value, fields, onError);
  const errorClass = error && displayErrors ? 'vds-form__radios--error' : '';
  let radioItemsClass = 'vds-form__radios ' + errorClass;
  if (fields.variant) {
    radioItemsClass += `  vds-form__radios--${fields.variant.value}`;
  } else {
    radioItemsClass += ' vds-form__radios--contained';
  }

  const handleChange = e => {
    const { value } = e.target;
    setSelectedValue(value);
    if (value) {
      dispatchError(fields, value, setError, dispatch);
    } else {
      resetError(fields, setError);
    }
  };

  useEffect(() => {
    handleChange({ target: { value: selectedValue } });
  }, []);

  return (
    <div className="vds-form__group vds-form__group--limited-width radio-btn-added-width btn-center">
      <fieldset className="vds-form__fieldset">
        <legend className="vds-form__label">
          {fields.label?.value}
          {fields.tooltipText?.value && (
            <Tooltip tooltipText={fields.tooltipText} fields={fields} />
          )}
        </legend>
        <div className={radioItemsClass} name={fields.name?.value}>
          <Placeholder
            name="radio-items"
            rendering={rendering}
            onChange={handleChange}
            id={rendering.uid}
            value={selectedValue}
            required={fields.required?.value}
            error={error && displayErrors}
          />
        </div>
        {displayErrors && fields.inlineError?.value && error && (
          <div className="vds-form__radio-conditional">
            <div className="vds-form__validation-message vds-form__validation-message--invalid">
              <span
                className="vds-form__validation-text"
                data-errormessageorigin={error?.name}
                data-errormessagetype={error?.type}
                data-testid="error-message"
              >
                {error?.message}
              </span>
            </div>
          </div>
        )}
      </fieldset>
    </div>
  );
};

const dispatchError = function (fields, value, setError, dispatch) {
  if (fields.compulsoryAnswerValue?.value && fields.compulsoryAnswerValue?.value !== value) {
    setError(errorMessages.INVALID);
  } else {
    setError(null);
  }
  const index = fields.reduxDispatchType?.payload?.index;
  const dispatchData = {
    type: fields.reduxDispatchType?.value,
    payload: index >= 0 ? { value, index } : value,
  };
  dispatch(dispatchData);
};

const resetError = function (fields, setError) {
  if (fields.required?.value) {
    setError(errorMessages.EMPTY);
  } else {
    setError(null);
  }
};

const mapStateToProps = (state, props) => {
  const reduxValuePath = props.fields.reduxValuePath?.value;
  let defaultValue;
  if (reduxValuePath) {
    defaultValue = resolve(reduxValuePath, state);
  }
  return {
    ...props,
    defaultValue,
    displayErrors:
      props.displayErrors ||
      state.appState?.displayErrors ||
      (defaultValue !== undefined &&
        props.fields.compulsoryAnswerValue?.value &&
        props.fields.compulsoryAnswerValue?.value !== props.value),
  };
};
export default connect(mapStateToProps)(RadioQuestion);
